import { topicRepository } from "../../../providers/repositories/topicRepository";
import { Topic } from "../entities/Topic";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const updateTopicOrderUseCase = {
    async exec(list: Topic[]): Promise<boolean> {
        try {
            await topicRepository.updateOrder(list);
            toast.success(t('action.updateSuccess'));
            return true;
        } catch (error) {
            toast.error(t('action.updateError'));
            Logger.error('updateTopicOrderUseCase', error);
        }
        return false;
    },
}; 